module.exports = __webpack_public_path__ + "images/novoxa5ca3c6c6e987521e87426a55743ffc0.png";